import { Component } from '@angular/core';
import { LayoutComponent } from './components/templates/layout/layout.component';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [LayoutComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'copec-oidc-auth';

  constructor(
  private matIconRegistry: MatIconRegistry,
  private sanitizer: DomSanitizer
) {
  this.matIconRegistry.addSvgIcon(
    'calendar',
    this.sanitizer.bypassSecurityTrustResourceUrl(
      'assets/svgs/calendar.svg'
    )
  );
}
}
